import { twMerge } from "@stereoagency/tailwind-config";
import React, { forwardRef } from "react";
function $Container(param, ref) {
    var name = param.name, _param_background = param.background, background = _param_background === void 0 ? "default" : _param_background, children = param.children, style = param.style, className = param.className, containerClassName = param.containerClassName;
    return /*#__PURE__*/ React.createElement("section", {
        ref: ref,
        style: style,
        "data-section-name": name,
        "data-section-background": background,
        className: twMerge(className, background === "subtle" && "bg-bg-subtle")
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge("container", containerClassName)
    }, children));
}
var Container = /*#__PURE__*/ forwardRef($Container);
export default Container;

//# sourceMappingURL=Container.js.map